import IdmissionFaceValidationMobile from './IdmissionFaceValidationMobile';

export default function VerifySelfieScreen() {
  return <IdmissionFaceValidationMobile />;
}
